const pad = (n) => String(n).padStart(2, '0');

export const fmtDate = (d) => {
  const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(d || '');
  return m ? `${m[3]}/${m[2]}/${m[1]}` : (d || '');
};

export const fmtTime = (t) => {
  const m = /^(\d{1,2})[:h](\d{2})/.exec(t || '');
  return m ? `${pad(m[1])}h${m[2]}` : (t || '');
};

export const fmtDateTime = (d, t) => (t ? `${fmtDate(d)} às ${fmtTime(t)}` : fmtDate(d));

export const fmtStamp = (iso) => {
  if (!iso) return '';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return fmtDate(iso);
  const p = Object.fromEntries(new Intl.DateTimeFormat('pt-PT', { timeZone: 'Europe/Lisbon', day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit', hourCycle: 'h23' }).formatToParts(d).map(x => [x.type, x.value]));
  return `${p.day}/${p.month}/${p.year} às ${p.hour}h${p.minute}`;
};

export const fmtDay = (iso) => {
  if (!iso) return '';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return fmtDate(iso);
  const p = Object.fromEntries(new Intl.DateTimeFormat('pt-PT', { timeZone: 'Europe/Lisbon', day: '2-digit', month: '2-digit', year: 'numeric' }).formatToParts(d).map(x => [x.type, x.value]));
  return `${p.day}/${p.month}/${p.year}`;
};

const MESES = ['janeiro', 'fevereiro', 'março', 'abril', 'maio', 'junho', 'julho', 'agosto', 'setembro', 'outubro', 'novembro', 'dezembro'];
export const MONTHS_PT = MESES;
export const fmtMonth = (ym) => {
  const m = /^(\d{4})-(\d{2})/.exec(ym || '');
  return m ? `${MESES[Number(m[2]) - 1] || m[2]} ${m[1]}` : (ym || '');
};

export const countsLabel = (x) => {
  const c = Number(x?.consultations_count || 0);
  const i = Number(x?.installments_count || 0);
  const parts = [];
  if (c > 0 || i === 0) parts.push(`${c} ${c === 1 ? 'consulta' : 'consultas'}`);
  if (i > 0) parts.push(`${i} ${i === 1 ? 'prestação' : 'prestações'}`);
  return parts.join(' · ');
};
